import { styled } from "styled-components";

export const PurchasedInfoDetail = styled.span`
  font-size: 18px;
`;
